import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { PortalCollapsibleComponent } from '../../../../customer-portal/components/portal-collapsible/portal-collapsible.component';
import { SharedModule } from '../../../../shared/shared.module';
import { PoolObject } from 'app/core/contract/poolObject.model';
import { PortalDeviceDetailsComponent } from 'app/products/electronic/components/portal-device-details/portal-device-details.component';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { isValidIMEI } from 'app/shared/helper-functions';

@Component({
    selector: 'app-b2b-insured-device',
    imports: [PortalCollapsibleComponent, SharedModule, PortalDeviceDetailsComponent, CtrlIconComponent],
    templateUrl: './b2b-insured-device.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class B2bInsuredDeviceComponent {
    public device = input.required<PoolObject>();

    public updateDevice = output<PoolObject[]>();

    protected isComplete = computed(() => {
        if (!this.device().ObjectDetail) {
            return false;
        }
        if (this.device().ObjectDetail.length < 4) {
            return false;
        }
        if (this.device().ObjectType === 'Smartphone') {
            return isValidIMEI(this.device().ObjectDetail);
        }
        return true;
    });

    protected title = computed(() => this.device().ObjectDescription + ' ' + this.device().ObjectModel);

    protected subtitle(): string {
        return (this.device().ObjectType === 'Smartphone' ? 'IMEI: ' : 'Seriennummer: ') + this.device().ObjectDetail;
    }

    protected icon = computed(() => {
        switch (this.device().ObjectType) {
            case 'Smartwatch':
                return 'smartwatch';
            case 'Kamera':
                return 'camera';
            case 'Notebook':
                return 'notebook';
            case 'Beamer':
                return 'beamer';
            case 'Objektiv':
                return 'lens';
            case 'Fernseher':
                return 'tv';
            case 'PC / Monitor':
                return 'pc-monitor';
            case 'Konsole':
                return 'console';
            case 'VR-Brille':
                return 'vr-glasses';
            case 'Kopfhörer':
                return 'headphones';
            case 'Smartphone':
                return 'smartphone-2';
            case 'Tablet':
                return 'tablet';
            default:
                return 'smartphone-2';
        }
    });

    protected subtitleAlert = computed(() => {
        if (this.isComplete()) {
            return undefined;
        } else {
            return this.device().ObjectType === 'Smartphone' ? 'IMEI fehlt' : 'Seriennummer fehlt';
        }
    });

    public submit(updatedDevices: PoolObject[]): void {
        this.updateDevice.emit(updatedDevices);
    }
}
